require("../ynet_magazine2025_yplus_site_audioArticlesRecommendationsComponenta.less")
require("./m_ynet_audioArticlesRecommendationsComponenta.less")
import { ProcessedAudioArticlesRecommendationsItem } from "../audioArticlesRecommendationsUtils";
import { AudioArticlesRecommendationsAction, AudioArticlesRecommendationsItemCard } from "./audioArticlesRecommendationsItemCard";
import { AudioArticlesRecommendationsPlayer } from "./audioArticlesRecommendationsPlayer";
import { WCM_BEPO_RECOMMENDATIONS_OPEN_EVENT } from "../../../article/componentas/articleHeaderComponenta/actionBarShared";

interface  AudioArticlesRecommendationsComponentaProps{
    listData?: ProcessedAudioArticlesRecommendationsItem[];
    isMobileWeb?: boolean;
    imagesDomain: string;
    domain: string;
};

interface AudioArticlesRecommendationsComponentaState {
    isOpen: boolean;
    selectedItem: ProcessedAudioArticlesRecommendationsItem | null;
}

export class AudioArticlesRecommendationsComponenta extends React.Component<AudioArticlesRecommendationsComponentaProps, AudioArticlesRecommendationsComponentaState> {

    public static siteScriptName = "AudioArticlesRecommendationsComponenta";

    private itemsContainerRef: HTMLDivElement;

    constructor(props: AudioArticlesRecommendationsComponentaProps) {
        super(props);
        this.state = {
            isOpen: false,
            selectedItem: null,
        };
    }

    componentDidMount() {
        if (typeof document === "undefined") {
            return;
        }
        document.addEventListener(WCM_BEPO_RECOMMENDATIONS_OPEN_EVENT, this.handleRecommendationsOpen);
    }

    componentWillUnmount() {
        if (typeof document === "undefined") {
            return;
        }
        document.removeEventListener(WCM_BEPO_RECOMMENDATIONS_OPEN_EVENT, this.handleRecommendationsOpen);
    }

    private hasRecommendationsData = () => {
        const { listData } = this.props;
        return !!(listData && listData.length > 0);
    }

    private handleRecommendationsOpen = () => {
        if (!this.hasRecommendationsData()) {
            return;
        }
        this.setState({ isOpen: true });
    }

    private onClose = () => {
        this.setState({ isOpen: false, selectedItem: null });
    }

    private openPlayer = (item: ProcessedAudioArticlesRecommendationsItem) => {
        this.setState({ selectedItem: item });
    }

    private closePlayer = () => {
        this.setState({ selectedItem: null });
    }

    private scrollItems = (direction: "left" | "right") => {
        const container = this.itemsContainerRef;
        if (!container) {
            return;
        }

        const scrollDistance = Math.max(280, Math.floor(container.clientWidth * 0.7));
        const delta = direction === "left" ? -scrollDistance : scrollDistance;

        container.scrollBy({
            left: delta,
            behavior: "smooth",
        });
    }

    render() {
        const { listData, imagesDomain, isMobileWeb } = this.props;

        if (!listData || listData.length === 0) {
            return null;
        }

        if (!this.state.isOpen) {
            return null;
        }

        const actions: AudioArticlesRecommendationsAction[] = ["share", "youtube", "apple", "spotify"];

        const items = (
            <div className="itemsContainer" ref={isMobileWeb ? undefined : (ref) => this.itemsContainerRef = ref}>
                {_.map(listData, (item: ProcessedAudioArticlesRecommendationsItem) => (
                    <AudioArticlesRecommendationsItemCard
                        key={item.id}
                        item={item}
                        imagesDomain={imagesDomain}
                        categoryIconFirst={!!isMobileWeb}
                        actions={actions}
                        onCardClick={this.openPlayer}
                    />
                ))}
            </div>
        );

        const header = (
            <div className="recommendationsHeader">
                <div className="headerTitleRow">
                    <div className="headerLogoWrap">
                        <span className="headerLogo" aria-hidden="true" />
                    </div>
                    <h3 className="headerTitle">אולי יעניין אתכם: חדש ב-</h3>
                </div>
            </div>
        );

        return (
            <>
                <div className="AudioArticlesRecommendationsComponenta">
                    <div className="recommendationsContainer">
                        <button className="closeButton" aria-label="close" onClick={this.onClose} />
                        {isMobileWeb ? (
                            <div className="recommendationsContent">
                                {header}
                                {items}
                            </div>
                        ) : (
                            <>
                                {header}
                                <button className="itemsArrow itemsArrowLeft" aria-label="scroll left" onClick={() => this.scrollItems("left")} />
                                {items}
                                <button className="itemsArrow itemsArrowRight" aria-label="scroll right" onClick={() => this.scrollItems("right")} />
                            </>
                        )}
                    </div>
                </div>
                {this.state.selectedItem && (
                    <AudioArticlesRecommendationsPlayer
                        item={this.state.selectedItem}
                        domain={this.props.domain}
                        isMobileWeb={!!isMobileWeb}
                        onClose={this.closePlayer}
                    />
                )}
            </>
        );
    }
}
